module.exports = __webpack_public_path__ + "img/ic-blokk.fafba2f6.svg";